import type { AccountThemeState, ResolvedThemeRuntime, ThemeAssetReference } from 'shared';
import { apiOrigin, http } from './client';

/** 主题图片必须是浏览器可直接访问的 API URL，桌面端不依赖页面自身的相对路径。 */
export function themeAssetUrl(url: string): string {
  return /^(?:https?:|data:)/.test(url) ? url : `${apiOrigin}${url}`;
}

export const themeApi = {
  runtime(): Promise<ResolvedThemeRuntime> {
    return http.get('/themes/runtime');
  },
  updateAccount(input: AccountThemeState): Promise<ResolvedThemeRuntime> {
    return http.patch('/themes/account', input);
  },
  assetUrl(packageId: string, releaseId: string, assetId: string): Promise<string> {
    return http.get<string>(`/themes/assets/${encodeURIComponent(packageId)}/${encodeURIComponent(releaseId)}/${encodeURIComponent(assetId)}/url`).then(themeAssetUrl);
  },
  uploadBackground(image: File): Promise<ResolvedThemeRuntime> {
    const body = new FormData();
    body.append('image', image);
    return http.post('/themes/background', body);
  },
  uploadThemeAsset(asset: File): Promise<{ asset: ThemeAssetReference; previewUrl: string }> {
    const body = new FormData();
    body.append('asset', asset);
    return http.post('/themes/assets', body);
  },
  uploadStyleSheet(styleSheet: File): Promise<{ source: string }> {
    const body = new FormData();
    body.append('styleSheet', styleSheet);
    return http.post('/themes/style-sheet', body);
  },
  uploadStoreScreenshot(screenshot: File): Promise<string> {
    const body = new FormData();
    body.append('screenshot', screenshot);
    return http.post<{ url: string }>('/themes/store-screenshots', body).then(({ url }) => themeAssetUrl(url));
  },
  uploadStoreCover(cover: File): Promise<string> {
    const body = new FormData();
    body.append('cover', cover);
    return http.post<{ url: string }>('/themes/store-covers', body).then(({ url }) => themeAssetUrl(url));
  },
  clearBackground(): Promise<ResolvedThemeRuntime> {
    return http.delete('/themes/background');
  },
};
